function complainsApi() {
	$(document).on('click', '[data-type-succes]', function (e) {
		let preloaderBtn = document.querySelector('[href="#popup-preloader--two"]')
		let resPopupBtn = document.querySelector('[href="#popup-success-res"]')
		let resPopups = document.querySelector('#popup-success-res')
		preloaderBtn.dispatchEvent(new Event('click'))
		// e.preventDefault();
		var $this = $(this)
		var $form = $this.closest('form')
		var formUrl = $form.attr('data-action')
		document.querySelector('.Complains__status-msg').removeAttribute('style')
		e.target.setAttribute('disabled', '')
		$.ajax({
			url: formUrl,
			// url: 'https://jsonplaceholder.typicode.com/posts',
			method: 'post', // Type of request to be send, called as method
			data: new FormData($form.get(0)), // Data sent to server, a set of key/value pairs (i.e. form fields and values)
			contentType: false, // The content type used when sending data to the server.
			cache: false, // To unable request pages to be cached
			processData: false, // To send DOMDocument or non processed data file it is set to false
			dataType: 'json',
			success: function (res) {
				if (!res.hasError) {
					$form.find('input, textarea').val('')
					$('.ctrFiles').html('')
				}

				if (res.status === 'success') {
					setTimeout(() => {
						$.fancybox.close()
					}, 1000)
					setTimeout(() => {
						resPopupBtn.dispatchEvent(new Event('click'))
						resPopups.querySelector('[data-title]').textContent = res.title
						resPopups.querySelector('[data-text]').textContent = res.text
						resPopups.querySelector('[data-title]').setAttribute('style', 'color: #9aca3c; padding-bottom: 30px;')
						resPopups.querySelector('[data-text]').setAttribute('style', 'color: #9aca3c;')

						setTimeout(() => {
							location.reload()
						}, 2500)
					}, 1200)
					document.querySelectorAll('.Complains__list-item > a').forEach(el => el.dispatchEvent(new Event('click')))
				} else {
					setTimeout(() => {
						$.fancybox.close()
					}, 1000)
					setTimeout(() => {
						resPopupBtn.dispatchEvent(new Event('click'))
						resPopups.querySelector('[data-title]').textContent = res.title
						resPopups.querySelector('[data-text]').textContent = res.text
						resPopups.querySelector('[data-title]').setAttribute('style', 'color: #9aca3c; padding-bottom: 30px;')
						resPopups.querySelector('[data-text]').setAttribute('style', 'color: #9aca3c;')
					}, 1200)
				}
			},
			error: function (p1, p2, p3) {
				setTimeout(() => {
					$.fancybox.close()
				}, 1000)
				setTimeout(() => {
					resPopupBtn.dispatchEvent(new Event('click'))
					resPopups.querySelector('[data-title]').textContent = 'Ошибка!'
					resPopups.querySelector('[data-text]').textContent = 'Заявка не отправлена'
					resPopups.querySelector('[data-title]').setAttribute('style', 'color: red; padding-bottom: 30px;')
					resPopups.querySelector('[data-text]').setAttribute('style', 'color: red;')
				}, 1200)
			},
		})

		return false
	})
	document.querySelector('[data-type-succes]').click()
}

function validateComplains() {
	if (document.querySelector('.Complains__form')) {
		let form = document.querySelector('.Complains__form')
		let inputs = form.querySelectorAll('.Input__inp')

		inputs.forEach(inp => {
			inp.oninput = inp.onchange = valInp(inp)

			function valInp(inp) {
				return e => {
					e.preventDefault()
					if (inp.value) {
						inp.classList.add('Input--valid')
						inp.classList.remove('Input--invalid')
					} else {
						inp.classList.remove('Input--valid')
						inp.classList.add('Input--invalid')
					}
				}
			}
		})

		form.querySelectorAll('[data-name="date"]').forEach(el => {
			el.addEventListener('focus', () => {
				el.oninput = () => {
					let arr = el.value
					arr = arr.split('-')
					if (parseInt(arr[0]) > 2030) {
						arr[0] = new Date().getFullYear()
						el.value = `${arr[0]}-${arr[1]}-${arr[2]}`
					}
				}
			})
		})
	}
}
